<template>
  <div class="app-container">
    <!-- 菜单部分 - 保持在顶部 -->
    <div class="menu-section">
      <div class="menu-container">
        <!-- 一级菜单 -->
        <div class="first-level-menu">
          <div
              v-for="(item, index) in menuData"
              :key="index"
              :class="[
              'first-level-item',
              { active: activeFirstLevel === index },
            ]"
              @click="selectFirstLevel(index)"
          >
            <!-- 文字部分 -->
            <div class="menu-text">{{ item.name }}</div>
            <!-- 箭头图标（除了总体结果） -->
            <div
                v-if="index > 0"
                class="arrow-icon"
                :class="{
                'arrow-up': activeFirstLevel === index,
                'arrow-down': activeFirstLevel !== index,
              }"
            ></div>
          </div>
        </div>

        <!-- 二级菜单（仅在非"总体结果"时显示） -->
        <div v-if="activeFirstLevel > 0" class="second-level-menu">
          <div class="scroll-wrapper">
            <div
                v-for="(subItem, subIndex) in menuData[activeFirstLevel].children"
                :key="subIndex"
                :class="[
                'second-level-item',
                { active: activeSecondLevel === subIndex },
              ]"
                @click="selectSecondLevel(subIndex)"
            >
              {{ subItem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容部分 - 确保不会覆盖菜单 -->
    <div class="content-section">
<!--      <div class="onebyone-progress" v-if="showOnlyCurrent && seqSteps.length">-->
<!--        当前：{{ seqPos + 1 }}/{{ seqSteps.length }}-->
<!--      </div>-->

      <div v-if="activeFirstLevel === 0">
        <!-- 为PortraitLevel2添加容器，限制其布局 -->
        <div class="portrait-level2-container">
          <PortraitLevel2 :portraitData="portraitData" :lessonId="lessonId" @jump-module="onJumpModule" />
        </div>
      </div>
      <div v-else>
        <SecondRule :data="currentData" :videoId="videoId" :on-click="handleActionButtonClick" />

        <div class="second-rule-divider"></div>

        <!-- 动态生成的内容区域 -->
        <!-- 每个 child 一个 row -->
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col
              v-for="(child, index) in currentData.children"
              :key="(currentData.id || 'summary') + '-child-' + index"
              :span="getSpan(child)"
              style="margin-bottom: 20px"
          >
            <component
                v-if="componentMap[child.name]"
                :is="componentMap[child.name].component"
                :data="child"
            />

            <component
                v-else
                :is="getReportStyleComponent(child.displayType)"
                :data="child"
                :on-click="handleActionButtonClick"
            />


          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog :visible.sync="showModal" width="1338px" :modal="false" :title="modalData.title" :center="true">


      <DetailModal :data="modalData" />
    </el-dialog>
    <!-- 评分弹窗 - 使用el-dialog和el-rating -->
    <el-dialog title="评价" :visible.sync="showRatingDialog" width="30%" :close-on-click-modal="false" :modal="true"
               :append-to-body="true" :z-index="2000">
      <div class="rating-dialog-row">
        <div class="rating-dialog-main">
          <p class="rating-dialog-title">{{ ratingInfo.indicatorName }}</p>
          <el-rate v-model="currentRating" :max="5" :show-score="true" text-color="#ff9900"
                   style="font-size: 24px;" />
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="handleRatingCancel">取消</el-button>
                <el-button type="primary" @click="handleRatingSubmit" :disabled="currentRating === 0">
                    提交
                </el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import SecondRule from "./SecondRule.vue";
import ReportStyle1 from './reportStyle1.vue';
import ReportStyle2 from './reportStyle2.vue';
import ReportStyle3 from './reportStyle3.vue';
import ReportStyle4 from "./reportStyle4.vue";
import SysVolumeAnalysis from "./SysVolumeAnalysis.vue";
import SysSpeechRateAnalysis from "./SysSpeechRateAnalysis.vue";
import SysTeacherAudio from "./SysTeacherAudio.vue";
import SysStCoding from "./SysStCoding.vue";
import SysTeacherActivity from "./SysTeacherActivity.vue";
import SysTeacherEmoji from "./SysTeacherEmoji.vue";
import DetailModal from "./DetailModal.vue";
import PortraitLevel2 from "./PortraitLevel2.vue";
import { submit_feedback } from "@/request/api/lession.js";
export default {
  name: 'PortraitLevel3',
  components: {
    ReportStyle1, ReportStyle2, ReportStyle3,
    ReportStyle4,
    SecondRule,
    DetailModal,
    PortraitLevel2,
    SysVolumeAnalysis,
    SysSpeechRateAnalysis,
    SysTeacherAudio,
    SysStCoding,
    SysTeacherActivity,
    SysTeacherEmoji,
  },
  props: {
    portraitData: {
      type: Object,
      default: null
    },
    lessonId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      componentMap: {
        "音量时间变化分析": {
          component: "SysVolumeAnalysis",
          span: 12,
        },
        "语速时间变化分析": {
          component: "SysSpeechRateAnalysis",
          span: 12,
        },
        "教师语音综合分析": {
          component: "SysTeacherAudio",
          span: 24,
        },
        "对话编码数据S-T分析": {
          component: "SysStCoding",
          span: 24,
        },
        "教师活动情况分析": {
          component: "SysTeacherActivity",
          span: 24,
        },
        "教师行为表情情况分析": {
          component: "SysTeacherEmoji",
          span: 24,
        },
      },
      portraitEvalSlider: 70, // 课堂画像评价右侧滑动条
      // 菜单数据
      menuData: [
        {
          name: '总体结果',
          // 总体结果没有子菜单
        }
      ],
      //指标列表
      indicatorList: [],
      // ✅ 单条模式：必须按顺序逐条评价才能看到下一条
      showOnlyCurrent: true,
      // 顺序步骤（由 processData 构建）
      seqSteps: [],
      // 当前步骤位置
      seqPos: 0,
      // fi-si -> pos 的映射，用于判断哪些菜单可见/可点
      stepPosMap: {},
      videoId: '',
      // 当前选中的一级菜单索引
      activeFirstLevel: 0,
      // 当前选中的二级菜单索引
      activeSecondLevel: 0,
      // 当前选中的指标数据
      currentData: null,
      currentIndex: 0,
      // 弹窗显示状态
      showModal: false,
      // 弹窗数据
      modalData: {
        title: '正向证据',
        videoId: '',
        indicatorName: '',
        evidences: [
        ],
        gainList: [],
        lossList: [],
      },
      showRatingDialog: false,
      currentRating: 0,
      ratingInfo: {
        indicatorName: '',
        id:0,
      }
    }
  },
  watch: {
    portraitData: {
      handler(newData) {
        if (newData) {
          this.processData(newData);
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['logout']),
    // 总体结果页「课堂数据」模块入口跳转：命中已解锁的一级菜单则切换过去
    onJumpModule(name) {
      if (!name) return;
      const idx = (this.menuData || []).findIndex(m => m && m.name === name);
      if (idx <= 0) {
        this.$notify.info({ title: '提示', message: '当前评课模板未包含该分析模块' });
        return;
      }
      if (this.isVisibleFirst(idx)) {
        this.selectFirstLevel(idx);
      } else {
        this.$notify.warning({ title: '提示', message: '请按顺序完成当前评价后再查看该模块' });
      }
    },
    getSpan(child) {
      if (this.componentMap[child.name]) {
        return this.componentMap[child.name].span;
      }

      // 其它组件根据 width
      if (child.width) {
        return child.width;
      }
      return 24;
    },
    getReportStyleComponent(type) {
      switch (type) {
        case '1':
          return "ReportStyle1";
        case '2':
          return "ReportStyle2";
        case '3':
          return "ReportStyle3";
        case '4':
          return "ReportStyle4";
        default:
          return "ReportStyle4";
      }
    },
    processData(data) {
      this.menuData = [{
        name: '总体结果',
      }, ...data.indicatorList];
      this.videoId = data.lesson.videoUrl;

      // ✅ 构建顺序步骤（忽略“总体结果”）
      const steps = [];
      for (let fi = 1; fi < this.menuData.length; fi++) {
        const f = this.menuData[fi];
        const children = (f && f.children) ? f.children : [];
        if (children.length > 0) {
          for (let si = 0; si < children.length; si++) {
            steps.push({ firstIndex: fi, secondIndex: si });
          }
        } else {
          steps.push({ firstIndex: fi, secondIndex: -1 });
        }
      }
      this.seqSteps = steps;
      // ✅ 构建 stepPosMap：用于控制菜单“已评价可见 / 未评价不可见”
      const map = {};
      steps.forEach((s, pos) => { map[`${s.firstIndex}-${s.secondIndex}`] = pos; });
      this.stepPosMap = map;

      // ✅ 初始化当前位置：跳到第一条未评价（如果后端带了已评价分数，可在这里进一步判断）
      this.seqPos = 0;
      if (this.showOnlyCurrent && this.seqSteps.length > 0) {
        this.gotoStep(this.seqPos);
      }
    },
    // ✅ 单条模式：跳转到指定步骤并刷新当前展示内容
    gotoStep(pos) {
      if (!this.seqSteps || this.seqSteps.length === 0) return;
      const p = Math.min(Math.max(0, pos), this.seqSteps.length - 1);
      this.seqPos = p;
      const step = this.seqSteps[p];
      this.activeFirstLevel = step.firstIndex;
      this.activeSecondLevel = step.secondIndex >= 0 ? step.secondIndex : 0;
      this.handleMenuClick(step.firstIndex, step.secondIndex);
    },

    // 只显示当前一级菜单（以及可选：总体结果，这里严格只显示当前）
    isVisibleFirst(index) {
      // 总体结果始终可见
      if (index === 0) return true;
      if (!this.seqSteps || this.seqSteps.length === 0) return index === this.activeFirstLevel;
      // ✅ 已解锁（<=seqPos）的一级菜单都可见
      return this.seqSteps.some((s, pos) => pos <= this.seqPos && s.firstIndex === index);
    },

    // 只显示当前二级菜单
    isVisibleSecond(subIndex) {
      if (!this.seqSteps || this.seqSteps.length === 0) return subIndex === this.activeSecondLevel;
      const fi = this.activeFirstLevel;
      if (fi <= 0) return false;
      // ✅ 当前一级菜单下：已解锁（<=seqPos）的二级菜单可见
      return this.seqSteps.some((s, pos) => pos <= this.seqPos && s.firstIndex === fi && s.secondIndex === subIndex);
    },

    handleFirstClick(index) {
      if (!this.showOnlyCurrent) return this.selectFirstLevel(index);
      // 单条模式下不允许随意跳转
      //（如需允许回看，可在这里放开）
    },

    handleSecondClick(subIndex) {
      if (!this.showOnlyCurrent) return this.selectSecondLevel(subIndex);
      const fi = this.activeFirstLevel;
      // ✅ 允许跳转到“已评价/已解锁”的二级菜单
      const ok = this.seqSteps.some((s, pos) => pos <= this.seqPos && s.firstIndex === fi && s.secondIndex === subIndex);
      if (ok) this.selectSecondLevel(subIndex);
    },

// 选择一级菜单
    selectFirstLevel(index) {
      this.activeFirstLevel = index;
      // 重置二级菜单选中状态
      this.activeSecondLevel = 0;
      // 触发菜单点击事件
      if (index > 0 && this.menuData[index].children.length > 0) {
        this.handleMenuClick(index, 0);
      } else {
        this.handleMenuClick(index, -1);
      }
    },

    // 选择二级菜单
    selectSecondLevel(index) {
      this.activeSecondLevel = index;
      // 触发菜单点击事件
      this.handleMenuClick(this.activeFirstLevel, index);
    },

    // 处理菜单点击事件
    handleMenuClick(firstIndex, secondIndex) {

      // 更新当前选中的指标数据
      if (firstIndex > 0 && secondIndex >= 0 && this.menuData[firstIndex] && this.menuData[firstIndex].children) {
        // 如果选中了二级菜单，设置对应的二级指标数据
        this.currentData = {
          ...this.menuData[firstIndex].children[secondIndex],
          parentName: this.menuData[firstIndex].name,
          parentId: this.menuData[firstIndex].id
        };
      } else if (firstIndex > 0) {
        // 如果只选中了一级菜单，设置对应的一级指标数据
        this.currentData = {
          ...this.menuData[firstIndex],
          isFirstLevel: true
        };
      } else {
        // 如果选中的是总体结果，设置为空或特定的总体数据
        this.currentData = {
          name: '总体结果',
          isSummary: true
        };
      }
    },

    // 处理操作按钮点击事件
    handleActionButtonClick(type, childData = null) {
      // 获取要使用的数据，优先使用子项数据，没有则使用当前选中的父级数据
      const targetData = childData || this.currentData;

      const extraData = JSON.parse(targetData.extra);

      console.log('targetData is ', targetData);

      // 根据不同的按钮类型执行不同的操作
      switch (type) {
        case 'zx':
          this.modalData.title = '正向证据';
          this.modalData.evidences = (extraData.evidences || []).filter(item => item.direction === '加分');
          this.modalData.videoId = this.videoId;
          this.modalData.gainList = targetData.gainList || [];
          this.modalData.lossList = [];
          this.modalData.indicatorName = targetData.name;
          this.showModal = true;
          break;
        case 'fx':
          this.modalData.title = '负向证据';
          this.modalData.evidences = (extraData.evidences || []).filter(item => item.direction === '扣分');
          this.modalData.videoId = this.videoId;
          this.modalData.gainList = [];
          this.modalData.lossList = targetData.lossList || [];
          this.modalData.indicatorName = targetData.name;
          this.showModal = true;
          break;
        case 'jl':
          // 交流按钮的逻辑
          //this.modalData.title = '交流建议';
          //this.showModal = true;
          break;
        case 'pj':
          // 评价按钮的逻辑 - 使用el-dialog和el-rating
          // ✅ 单条模式：只有“当前待评价”这一条允许评价
          if (this.showOnlyCurrent && this.seqSteps && this.seqSteps.length > 0) {
            const cur = this.seqSteps[this.seqPos];
            if (cur && (this.activeFirstLevel !== cur.firstIndex || this.activeSecondLevel !== cur.secondIndex)) {
              this.$notify.warning({ title: '提示', message: '请按顺序评价：先完成当前条目再评价下一条' });
              return;
            }
          }
          this.ratingInfo.indicatorName = targetData.name;
          this.ratingInfo.id=targetData.id;
          this.currentRating = 0;
          this.showRatingDialog = true;
          break;
        default:
          console.log('未知按钮类型');
      }
    },

    // 打开弹窗
    openModal() {
      this.showModal = true;
    },

    // 关闭弹窗
    closeModal() {
      this.showModal = false;
    },
    handleRatingSubmit() {
      if (this.currentRating > 0) {
        if (this.ratingSubmitting) return;
        this.ratingSubmitting = true;

        const formData = {
          lessonId: this.lessonId,
          groupId: this.menuData[this.activeFirstLevel].id,
          itemId: this.ratingInfo.id,
          score: this.currentRating,
        };

        submit_feedback(formData).then(() => {
          // ✅ 计算剩余未评价条数（feedbackScore 仍为 null/undefined 的条目）
          const remaining = (this.tableData || []).filter(r =>
              r.feedbackScore === null || r.feedbackScore === undefined
          ).length;

          this.$notify({
            title: '成功',
            message: remaining > 0 ? `已评价，进入下一条；剩余 ${remaining} 条` : '已评价；剩余 0 条（全部完成）',
            type: 'success'
          });

          // // ✅ 推进到下一条未评价
          // let next = currentIndex + 1;
          // while (
          //     next < this.tableData.length &&
          //     this.tableData[next].feedbackScore !== null &&
          //     this.tableData[next].feedbackScore !== undefined
          //     ) {
          //   next++;
          // }
          // if (next < this.tableData.length) {
          //   this.unlockIndex = next;
          // }
        }).catch(() => {
          this.$notify.error({ title: '错误', message: '评分提交失败，仍停留在当前条' });
        }).finally(() => {
          this.ratingSubmitting = false;
        });
      }
    },
    handleRatingCancel() {
      this.currentRating = 0;
      this.showRatingDialog = false;
    }
  },
  mounted() {
    // ✅ 单条模式：默认跳到第一条步骤
    if (this.showOnlyCurrent && this.seqSteps && this.seqSteps.length > 0) {
      this.gotoStep(this.seqPos || 0);
      return;
    }

    // 默认行为（非单条模式）
    if (this.activeFirstLevel > 0 && this.menuData[this.activeFirstLevel].children.length > 0) {
      this.activeSecondLevel = 0;
      this.handleMenuClick(this.activeFirstLevel, this.activeSecondLevel);
    } else if (this.activeFirstLevel === 0) {
      this.handleMenuClick(0, -1);
    }
  },
};
</script>
<style scoped lang="less">
.onebyone-progress{
  color:#fff;
  font-size:16px;
  margin:10px 0;
}

/* 引入阿里巴巴普惠体常规字体 */
@font-face {
  font-family: 'AlibabaPuHuiTi';
  src: url('../../../assets/fonts/AlibabaPuHuiTi-3-55-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

/* 引入阿里巴巴普惠体粗体字体 */
@font-face {
  font-family: 'AlibabaPuHuiTi-Bold';
  src: url('../../../assets/fonts/AlibabaPuHuiTi-3-85-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}

/* 全局字体设置 */
* {
  font-family: AlibabaPuHuiTi;
}

// 修复高度继承问题 - 设置根元素高度
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.app-container {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .menu-section {
    width: 100%;
    z-index: 10;
    background: inherit;
    padding: 10px;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  /* 内容部分 - 占据剩余空间 */
  .content-section {
    flex: 1;
    width: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 20px;

    /* PortraitLevel2容器，限制其布局 */
    .portrait-level2-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 28, 53, 0.1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(5, 133, 247, 0.5);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(5, 133, 247, 0.8);
    }

    /* 确保栅格布局正常显示 */
    .el-row {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      overflow: visible;
      margin-right: 0 !important;
      margin-left: 0 !important;
    }

    /* 列样式增强 */
    .el-col {
      box-sizing: border-box;
      min-width: 0;
    }

    /* 为所有Report组件添加统一的容器样式 */
    .el-col>* {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      min-width: 0;
    }

    /* 防止文本溢出 */
    .text-content {
      word-wrap: break-word !important;
      word-break: break-all !important;
      overflow-wrap: break-word !important;
    }
  }

  /* 菜单容器样式 */
  .menu-container {
    width: 100%;
  }

  /* 一级菜单样式 */
  .first-level-menu {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px 2px 12px;
    /* 隐藏滚动条但保留滚动功能 */
    scrollbar-width: thin;
    scrollbar-color: rgba(5, 133, 247, 0.5) transparent;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(63, 156, 255, 0.18);
  }

  /* 自定义一级菜单滚动条样式 */
  .first-level-menu::-webkit-scrollbar {
    height: 6px;
  }

  .first-level-menu::-webkit-scrollbar-track {
    background: transparent;
  }

  .first-level-menu::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.5);
    border-radius: 3px;
  }

  .first-level-menu::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 0.8);
  }

  .first-level-item {
    min-width: 132px;
    height: 38px;
    padding: 0 18px;
    cursor: pointer;
    color: #7ea6d9;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: rgba(13, 40, 95, 0.35);
    border: 1px solid rgba(44, 88, 125, 0.6);
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.2s ease;
    white-space: nowrap;
    box-sizing: border-box;
    position: relative;

    &:hover {
      border-color: rgba(79, 195, 255, 0.6);
      color: #9fc7f0;
    }
  }

  /* 菜单文字样式 */
  .menu-text {
    font-weight: 400;
    color: inherit;
    font-size: 14px;
  }

  /* 箭头图标样式 */
  .arrow-icon {
    width: 8px;
    height: 8px;
    margin-left: 8px;
    border-right: 1.5px solid currentColor;
    border-bottom: 1.5px solid currentColor;
    transition: all 0.2s ease;
    opacity: 0.85;
    background: none;
  }

  .arrow-down {
    transform: rotate(45deg) translateY(-2px);
  }

  .arrow-up {
    transform: rotate(-135deg) translateY(-2px);
  }


  .first-level-item.active {
    color: #eaf6ff;
    font-weight: 500;
    background: linear-gradient(180deg, rgba(42, 125, 232, 0.6), rgba(27, 98, 224, 0.25));
    border-color: #4fc3ff;
    box-shadow: 0 0 12px rgba(42, 125, 232, 0.55);
  }

  /* 选中状态下的文字渐变效果 */
  .first-level-item.active .menu-text {
    color: #eaf6ff;
    font-weight: 500;
  }

  /* 二级菜单样式 */
  .second-level-menu {
    margin-top: 10px;
    background: transparent;
    border-radius: 4px;
    padding: 0;
  }

  .scroll-wrapper {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 5px;
    scrollbar-width: thin;
    scrollbar-color: rgba(5, 133, 247, 0.5) rgba(0, 28, 53, 0.1);
  }

  /* 自定义二级菜单滚动条 */
  .scroll-wrapper::-webkit-scrollbar {
    height: 6px;
  }

  .scroll-wrapper::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1);
    border-radius: 3px;
  }

  .scroll-wrapper::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.5);
    border-radius: 3px;
  }

  .scroll-wrapper::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 0.8);
  }

  .second-level-item {
    padding: 5px 14px;
    margin-right: 10px;
    cursor: pointer;
    color: #9ec7ff;
    border-radius: 20px;
    line-height: 18px;
    font-size: 12px;
    transition: all 0.2s ease;
    white-space: nowrap;
    background: rgba(27, 98, 224, 0.16);
    box-sizing: border-box;
    border: 1px solid rgba(63, 156, 255, 0.4);
    box-shadow: none;
  }

  .second-level-item:hover {
    border-color: rgba(79, 195, 255, 0.75);
    color: #eaf6ff;
    background: rgba(27, 98, 224, 0.3);
  }

  .second-level-item.active {
    color: #eaf6ff;
    background: linear-gradient(180deg, rgba(42, 125, 232, 0.6), rgba(27, 98, 224, 0.25));
    border-color: #4fc3ff;
    box-shadow: 0 0 10px rgba(42, 125, 232, 0.45);
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .first-level-menu {
      flex-wrap: wrap;
    }

    .first-level-item {
      margin-bottom: 8px;
    }
  }
}

.second-rule-divider {
  background: url(../../../assets/image/rule-divider.png) no-repeat center center;
  width: 100%;
  height: 20px;
  margin: 20px 0;
}

//二级指标
.second-rule-container {
  display: flex;
  flex-direction: column;
  background: rgba(0, 28, 53, 0.7);
  box-sizing: border-box;
  border: 1px solid;
  margin-bottom: 20px;
  border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

  .header {
    height: 40px;
    background-color: rebeccapurple;
    width: 100%;
    background: linear-gradient(90deg, rgba(13, 80, 146, 0.5) 0%, rgba(13, 80, 146, 0.5) 100%);
    position: relative;

    .header-text {
      color: #ffffff;
      font-size: 20px;
      text-align: center;
      line-height: 40px;
      /* 与header高度一致，确保垂直居中 */
      background: url(../.././../assets/image/rule-name-bg.png) no-repeat;
      width: 420px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }

    .second-rule-text {
      font-size: 18px;
      color: #FFFFFF;
      line-height: 34px;
    }
  }
}

/deep/ .el-dialog {
  background: rgba(0, 74, 140, 0.5);
  border: 1px solid rgba(5, 133, 247, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/deep/ .el-dialog__header {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 20px;

  span {
    color: #fff;
  }

  font-size: 20px;
  line-height: 20px;
  font-weight: 500;
  background: url(../../../assets/image/modal-header.png) no-repeat center center !important;
}

.rating-dialog-row{
  display:flex;
  align-items:center;
  justify-content: center;
  padding: 20px 0;
}
.rating-dialog-main{
  flex: 1;
  text-align: center;
}
.rating-dialog-title{
  margin-bottom: 20px;
  color: #fff;
}
.rating-dialog-slider{
  width: 92px;
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content:center;
}
.rating-slider-label{
  margin-top: 8px;
  font-size: 12px;
  color: #fff;
  opacity: 0.85;
}
</style>
